import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import {
  EditButtonWrapperStyled,
  ExtraInfoStyled,
  GoPaperlessContainerStyled,
  ImageStyled,
  PaperlessImageContainerStyled,
  TextMessageToggleContainerStyled,
} from 'enrollment/features';
import goPaperless from '../../assets/goPaperless.svg';
import happyEarth from '../../assets/happyEarth.svg';
import { Spacer } from 'theSource/components';
import 'enrollment/features/CommunicationPreferences/components/GoPaperless/GoPaperlessStyles.css';
import { PsDrawerDialog } from 'stencilSetup';

interface GoPaperlessProps {
  checked: boolean | undefined;
}

export const GoPaperless = ({ checked }: GoPaperlessProps) => {
  const { t } = useTranslation('pages.communicationPreferencesLumos');
  const [paperless, setPaperless] = useState(Boolean(checked));
  const removeListenerController = new AbortController();

  const handleChange = () => {
    removeListenerController.abort(); // used to detach any previous event listeners
    setPaperless(!paperless);
  };

  useEffect(() => {
    // small timeout for new component to render
    setTimeout(() => {
      const toggle = document.getElementById('paperless');
      if (!toggle) {
        return;
      }
      toggle.addEventListener(
        'change',
        () => {
          handleChange();
        },
        { signal: removeListenerController.signal }
      );
    }, 100);
  });

  return (
    <>
      <h2 className="headline-3">{t('goPaperless')}</h2>
      <GoPaperlessContainerStyled>
        <Spacer height={3} />

        <PaperlessImageContainerStyled>
          {paperless ? (
            <ImageStyled src={happyEarth} alt="paperless" />
          ) : (
            <ImageStyled src={goPaperless} alt="not paperless" />
          )}
        </PaperlessImageContainerStyled>

        <Spacer height={5} />
        <TextMessageToggleContainerStyled>
          <EditButtonWrapperStyled>
            <ps-toggle-switch
              checked={checked ? true : null}
              input-id="paperless"
              label={t('1095c')}
              extra-class="text-dark"
            ></ps-toggle-switch>
          </EditButtonWrapperStyled>
          <ExtraInfoStyled className="body2">
            {t('goPaperlessInfo')}
          </ExtraInfoStyled>
        </TextMessageToggleContainerStyled>

        <Spacer height={2} />

        <PsDrawerDialog
          dialogId="disclaimer_drawer"
          dialogTriggerLabel={t('disclaimer')}
          dialogHeading={t('disclaimerTitle')}
          dialogButtonLabel="invisible"
          dialogTriggerClass="disclaimer-link"
          dialogLarge
          dialogTriggerLink
        >
          <Box>{t('1095cDisclaimer')}</Box>
        </PsDrawerDialog>
      </GoPaperlessContainerStyled>
    </>
  );
};
